import {imageMap} from "../../images/imageMap.ts";
import Routing from "../../Routing.ts";

export type Job = {
    date: string
    img_list: string
    img_alt: string
    title: string
    description: string
    heading: string
    link: string
}

export const JobsPostings: {
    CXManager20250626: Job,
    CustomerService20250528: Job,
    SalesConsultant20250528: Job,
} = {
    CXManager20250626: {
        date: "2025-06-26",
        img_list: imageMap.jobs.three_employess_speaking,
        img_alt: "CX Manager søges til Hiper",
        title: "CX Manager søges til Hiper",
        description: "Vi søger en CX Manager, der både kan tænke strategisk og arbejde praktisk med at forbedre kundeoplevelser, baseret på data og indsigter.",
        heading: "CX Manager til Hiper",
        link: Routing.About.Jobs.Postings.CXManager,
    },
    CustomerService20250528: {
        date: "2025-05-28",
        img_list: imageMap.jobs.two_employess_working,
        img_alt: "Kundeservicemedarbejder søges til Hiper",
        title: "Kundeservicemedarbejder søges til Hiper",
        description: "Hiper søger nye kundeservicemedarbejdere til vores team i København SV. Er du klar til at gøre en forskel for vores kunder og være en del af et stærkt fællesskab?",
        heading: "Kundeservicemedarbejder søges til Hiper",
        link: Routing.About.Jobs.Postings.CustomerService,
    },
    SalesConsultant20250528: {
        date: "2025-05-28",
        img_list: imageMap.jobs.sales_person,
        img_alt: "Salgskonsulent i Hiper",
        title: "Salgskonsulent i Hiper",
        description: "Hiper søger en salgskonsulent, der vil være med til at gøre en forskel for vores kunder og samtidig være en del af et stærkt fællesskab. Er du klar til at tage udfordringen op?",
        heading: "Salgskonsulent i Hiper",
        link: Routing.About.Jobs.Postings.SalesConsultant,
    },
}
